import { render, staticRenderFns } from "./formScreen.vue?vue&type=template&id=4150d672&scoped=true&"
import script from "./formScreen.vue?vue&type=script&lang=js&"
export * from "./formScreen.vue?vue&type=script&lang=js&"
import style0 from "./formScreen.vue?vue&type=style&index=0&id=4150d672&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4150d672",
  null
  
)

export default component.exports